import { render } from "./ProfileDetailComponent.vue?vue&type=template&id=40f64d38&scoped=true"
import script from "./ProfileDetailComponent.vue?vue&type=script&lang=js"
export * from "./ProfileDetailComponent.vue?vue&type=script&lang=js"

import "./ProfileDetailComponent.vue?vue&type=style&index=0&id=40f64d38&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f64d38"]])

export default __exports__